export const selectStagesData = (state) => state.stages.data;
export const selectStagesStatus = (state) => state.stages.status;
export const selectStagesError = (state) => state.stages.error;